"use strict";

import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import { GoalsDataService } from "../../../presentation/services/GoalsDataService";
import { PublicCompany } from "../../../presentation/services/PublicCompany/PublicCompany";
import { SourceConvert } from "../../../presentation/services/SourceConvert/SourceConvert";
import "./configuration-goals-dialog.scss";
import "./configuration-goals-dialog-dark.scss";

class ConfigurationGoalsDialogCtrl {
    GoalsDataService = new GoalsDataService();
    goalsRules = [];
    currentDate = "";
    loading = false;
    optionsSelect = [
        "Igual a",
        "Maior ou igual a",
        "Maior que",
        "Menor ou igual a",
        "Menor que"
    ];
    constructor($mdDialog, locals, $scope) {
        this.$mdDialog = $mdDialog;
        this.locals = locals;
        this.$scope = $scope;
    }
    $onInit() {
        this.hasPermissionCompanyModel = PublicCompany.hasPermissionModelToModify(
            this.locals.companyData._id,
            new UserDataAdapter().user()
        );
        this.currentDate = new Date(this.locals?.currentPeriod?.date)
            .toLocaleDateString("pt-BR", {
                month: "numeric",
                year: "numeric"
            })
            .split("/")
            .reverse()
            .join("-");
        this.sourceHuman = SourceConvert.toHuman(
            this.locals.visualization?.sources?.[0]
        );
        this._setGoals();
    }
    async _setGoals() {
        this.loading = true;
        this.goalsRules = await this.GoalsDataService.getList({
            series: this.locals.series,
            visualization: this.locals.visualization
        });
        this.loading = false;
        this.$scope.$applyAsync();
    }
    async onSubmit() {
        this.loading = true;
        await this.GoalsDataService.save({
            projection: this.locals.projection,
            company: this.locals.companyData,
            goalsRules: this.goalsRules,
            date: this.locals?.currentPeriod?.date,
            source: this.locals.visualization?.sources?.[0],
            budget: this.locals.budget
        });
        this.$mdDialog.hide(true);
        this.loading = false;
    }
}

angular.module("nucont.shared").controller("ConfigurationGoalsDialogCtrl", [
    "$mdDialog",
    "locals",
    "$scope",
    ConfigurationGoalsDialogCtrl
]);
